module.exports = __webpack_public_path__ + "static/step1-element@2x-c853f3a856b847e97cf9cdec40229f14.png";